{
  "name": "finosetup",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "deploy": "bash ./bin/deploy.sh",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "serve_prep": "ng s --c=prep",
    "build_p": "ng build --c=production --output-hashing=all",
    "build_beta": "ng build --c=beta --output-hashing=all",
    "build_uat": "ng build --c=uat --output-hashing=all",
    "build_live": "ng build --c=production --output-hashing=all",
    "build_prep": "ng build --c=prep "
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.4",
    "@angular/cdk": "^20.2.8",
    "@angular/common": "^20.3.4",
    "@angular/compiler": "^20.3.4",
    "@angular/core": "^20.3.4",
    "@angular/forms": "^20.3.4",
    "@angular/localize": "^20.3.4",
    "@angular/platform-browser": "^20.3.4",
    "@angular/platform-browser-dynamic": "^20.3.4",
    "@angular/router": "^20.3.4",
    "@ng-bootstrap/ng-bootstrap": "^15.1.2",
    "@popperjs/core": "^2.11.5",
    "angular-credit-cards": "^1.0.2",
    "angular-moment": "^1.3.0",
    "angular-ng-autocomplete": "^2.0.8",
    "apexcharts": "^5.3.5",
    "async-wait-until": "^2.0.12",
    "bootstrap-select": "^1.13.18",
    "card-validator": "^8.1.1",
    "crypto-js": "^4.2.0",
    "fast-xml-parser": "^5.3.2",
    "file-saver": "^2.0.5",
    "font-awesome": "^4.7.0",
    "html2canvas": "^1.4.1",
    "html2pdf.js": "^0.10.1",
    "http-server": "^14.1.1",
    "jquery": "^3.6.0",
    "jsencrypt": "^3.5.4",
    "jspdf": "^3.0.3",
    "jwt-decode": "^4.0.0",
    "ng-apexcharts": "^1.9.0",
    "ng-qrcode": "^7.0.0",
    "ngx-bootstrap": "^20.0.2",
    "ngx-cookie-service": "^15.0.0",
    "ngx-pagination": "^6.0.3",
    "ngx-toastr": "^19.0.0",
    "rxjs": "7.8",
    "sweetalert2": "^11.11.0",
    "ts-md5": "^1.3.1",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.5",
    "@angular/cli": "^20.3.5",
    "@angular/compiler-cli": "^20.3.4",
    "@lsqswl/rsaencrypt": "^1.0.3",
    "@types/crypto-js": "^4.2.0",
    "@types/file-saver": "^2.0.5",
    "@types/jasmine": "~3.10.0",
    "@types/jquery": "^3.5.14",
    "@types/lodash": "^4.14.179",
    "@types/node": "^22.7.5",
    "bootstrap": "^4.6.1",
    "jasmine-core": "~3.10.0",
    "karma": "^6.4.3",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "~2.1.0",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "~1.7.0",
    "typescript": "^5.9.3"
  }
}
